import React from 'react';
interface ChargeLineItem {
  id: string;
  description: string;
  quantity: number;
  rate: number;
  amount: number;
}
interface ShipmentChargesProps {
  charges?: ChargeLineItem[];
  currency?: string;
}
const ShipmentCharges: React.FC<ShipmentChargesProps> = ({
  charges = [],
  // Provide default empty array
  currency = 'USD'
}) => {
  const total = charges.reduce((sum, charge) => sum + charge.amount, 0);
  if (!charges || charges.length === 0) {
    return <div className="text-center py-4 text-gray-500" data-id="element-307">No charges available</div>;
  }
  return <div className="overflow-hidden" data-id="element-308">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-309">
        <thead className="bg-gray-50" data-id="element-310">
          <tr data-id="element-311">
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-312">
              Description
            </th>
            <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-313">
              Quantity
            </th>
            <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-314">
              Rate
            </th>
            <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-315">
              Amount
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-316">
          {charges.map(charge => <tr key={charge.id} data-id="element-317">
              <td className="px-4 py-3 text-sm text-gray-900" data-id="element-318">
                {charge.description}
              </td>
              <td className="px-4 py-3 text-sm text-gray-900 text-right" data-id="element-319">
                {charge.quantity}
              </td>
              <td className="px-4 py-3 text-sm text-gray-900 text-right" data-id="element-320">
                {charge.rate.toLocaleString('en-US', {
              style: 'currency',
              currency: currency
            })}
              </td>
              <td className="px-4 py-3 text-sm text-gray-900 text-right" data-id="element-321">
                {charge.amount.toLocaleString('en-US', {
              style: 'currency',
              currency: currency
            })}
              </td>
            </tr>)}
          <tr className="bg-gray-50" data-id="element-322">
            <td colSpan={3} className="px-4 py-3 text-sm font-medium text-gray-900 text-right" data-id="element-323">
              Total
            </td>
            <td className="px-4 py-3 text-sm font-medium text-gray-900 text-right" data-id="element-324">
              {total.toLocaleString('en-US', {
              style: 'currency',
              currency: currency
            })}
            </td>
          </tr>
        </tbody>
      </table>
    </div>;
};
export default ShipmentCharges;